export default __webpack_public_path__ + "static/gba_ep4_compressed-03eb4db720f59aa816dd5c607cf9e05b.mp4";